const translates = {
    pt_BR: {
        //Contact
        name: 'O campo "Nome" não foi preenchido',
        email: {
            required: 'O campo "Email" não foi preenchido',
            email: 'Digite um "Email" válido',
        },
        phone: {
            required: 'O campo "Telefone" não foi preenchido',
            minlength: 'Digite um "Telefone" válido',
            phoneBr: 'Por favor, forneça um telefone válido no formato (XX) XXXX-XXXX ou (XX) XXXXX-XXXX.',
        },
        country_id: 'O campo "País" não foi definido',
        state_id: 'O campo "Estado" não foi definido',
        city_id: 'O campo "Cidade" não foi definido',
        contact_subject_id: 'O campo "Assunto" não foi definido',
        unit_id: 'O campo "Unidade" não foi definido',
        message: {
            required: 'O campo "Mensagem" não foi preenchido',
            maxlength: 'O campo "Mensagem" não deve conter mais de 400 caracteres.',
        },
        privacy: 'Você precisa aceitar as "Políticas de privacidade"',

        //Budget
        first_name: 'O campo "Nome" não foi preenchido',
        last_name: 'O campo "Nome" não foi preenchido',
        company: 'O campo "Empresa" não foi preenchido',
        product_id: 'O campo "Máquinas de interesse" não foi definido',

        //Selects
        select_state: 'Selecione seu estado',
        select_city: 'Selecione sua cidade',
        select_model: 'Selecione um modelo',

        emptySelect: 'SELECIONE',
        selectModel: 'SELECIONE UM MODELO',

        //Staramania
        placeholderStaramania:
            'Digite aqui as observações ou dúvidadas sobre o produto. Ex: Tamanho 42, Tamanho G e etc.',
        emptyCartStaramania: 'Nenhum produto adicionado no carrinho',
        removeProductStaramania: 'REMOVER PRODUTO',
    },
    en: {
        //Contact
        name: 'The field "Name" hasn\'t been filled out',
        email: {
            required: 'The field "Email" hasn\'t been filled out',
            email: 'Enter a valid "Email"',
        },
        phone: {
            required: 'The field "Phone number" hasn\'t been filled out',
            minlength: 'Enter a valid "Phone number"',
        },
        country_id: 'The field "Country" hasn\'t been filled out',
        state_id: 'The field "State" hasn\'t been filled out',
        city_id: 'The field "City" hasn\'t been filled out',
        contact_subject_id: 'The field "Subject" hasn\'t been filled out',
        unit_id: 'The field "Unit" hasn\'t been filled out',
        message: {
            required: 'The field "Message" hasn\'t been filled out',
            maxlength: 'The "Message" field must not contain more than 400 characters.',
        },
        privacy: 'You need to accept the "Privacy policies"',

        //Budget
        first_name: 'The field "Name" hasn\'t been filled out',
        last_name: 'The field "Lastname" hasn\'t been filled out',
        company: 'The field "Company" hasn\'t been filled out',
        product_id: 'The field "Machines of interest" hasn\'t been filled out',

        //Selects
        select_state: 'Select your state',
        select_city: 'Select your city',
        select_model: 'Choose a model',
        emptySelect: 'CHOOSE',
        selectModel: 'CHOOSE A MODEL',

        //Staramania
        placeholderStaramania: 'Enter your comments or questions about the product here. Ex: Size 42, Size L, etc.',
        emptyCartStaramania: 'No prodcust added.',
        removeProductStaramania: 'REMOVE PRODUCT',
    },
    es: {
        //Contact
        name: 'El campo "Nombre" no se ha completado',
        email: {
            required: 'El campo "Dirección electrónica" no se ha completado',
            email: 'Escriba una "dirección electrónica" válida',
        },
        phone: {
            required: 'El campo "Teléfono" no se ha completado',
            minlength: 'Escriba una "teléfono" válido',
        },
        country_id: 'El campo "País" no está definido',
        state_id: 'El campo "Estado" no está definido',
        city_id: 'El campo "Ciudad" no está definido',
        contact_subject_id: 'El campo "Asunto" no está definido',
        unit_id: 'El campo "Unidad" no está definido',
        message: 'El campo "Mensaje" no se ha completado',
        message: {
            required: 'El campo "Mensaje" no se ha completado',
            maxlength: 'El campo "Mensaje" no debe contener más de 400 caracteres.',
        },
        privacy: 'Es necesario que acepte las "Políticas de privacidad"',

        //Budget
        first_name: 'El campo "Nombre" no se ha completado',
        last_name: 'El campo "Nombre" no se ha completado',
        company: 'El campo "Asunto" no se ha completado',
        product_id: 'El campo "Máquinas de interés" no está definido',

        //Selects
        select_state: 'Seleccione su estado',
        select_city: 'Seleccione su ciudad',
        select_model: 'Seleccione un modelo',

        emptySelect: 'SELECCIONE',
        selectModel: 'SELECCIONE UN MODELO',

        //Staramania
        placeholderStaramania:
            'Introduzca aquí sus comentarios o preguntas sobre el producto. Ej: Talla 42, Talla L, etc.',
        emptyCartStaramania: 'No se agregaron productos al carrito',
        removeProductStaramania: 'REMOVER PRODUCTO',
    },
    ru: {
        //Contact
        name: 'Поле "Имя" не было заполнено',
        email: {
            required: 'Поле "Электронная почта" не было заполнено',
            email: 'Укажите действительный "адрес электронной почты".',
        },
        phone: {
            required: 'Поле "Номер телефона" не было заполнено',
            minlength: 'Укажите действительный "номер телефона"',
        },
        country_id: 'Поле "Страна" не было заполнено',
        state_id: 'Поле "Край/область" не было заполнено',
        city_id: 'Поле "Город" не было заполнено',
        contact_subject_id: 'Поле "Тема" не было заполнено',
        unit_id: 'Поле "Единица" не было заполнено',
        message: 'Поле "Сообщение" не было заполнено',
        message: {
            required: 'Поле "Сообщение" не было заполнено',
            maxlength: 'Поле "Сообщение" не должно содержать более 400 символов',
        },
        privacy: 'Вы должны принять условия "Политики конфиденциальности"',

        //Budget
        first_name: 'Поле "Имя" не было заполнено',
        last_name: 'Поле "Имя" не было заполнено',
        company: 'Поле "Компания" не было заполнено',
        product_id: 'Поле "Техника, что меня интересует" не было заполнено',

        //Selects
        select_state: 'Выберите ваш край/область',
        select_city: 'Выберите ваш город',
        select_model: 'Выберите модель',

        emptySelect: 'ВЫБЕРИТЕ',
        selectModel: 'ВЫБЕРИТЕ МОДЕЛЬ',

        //Staramania
        placeholderStaramania:
            'Введите здесь свои комментарии или вопросы о продукте. Пример: размер 42, размер L и т. д.',
        emptyCartStaramania: 'В корзину не добавлено ни одного товара',
        removeProductStaramania: 'УДАЛИТЬ ПРОДУКТ',
    },
};

//fallback
translates['pt-BR'] = translates.pt_BR;

export function getTranslatedMessages() {
    const currentLocale = window.currentLocale() ? window.currentLocale() : 'pt_BR';

    return translates[currentLocale];
}
